import React from "react";
import ButtonBase from "@mui/material/ButtonBase";
import { useNavigate } from "react-router";

import LogoImg from "../images/logo.svg";
import useDashboardLink from "../hooks/useDashboardLink";

export default function Logo({ src = LogoImg, ...props }) {
  const navigate = useNavigate();
  const dashboardLink = useDashboardLink();

  const handleClick = () => {
    navigate(dashboardLink);
  };

  return (
    <ButtonBase onClick={handleClick}>
      <img className={"logo"} alt="Logo" src={src} {...props} />
    </ButtonBase>
  );
}
